import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import clsx from "clsx";

import css from "./Header.module.css";
import MobileMenuHome from "../MobileMenuHome/MobileMenuHome.jsx";

const buildLinkClass = ({ isActive }) => {
  return clsx("nav-section", isActive && "active");
};

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className={css["container-header"]}>
      <nav className="nav">
        <Link to="/">
          <img
            src="/img/SOLVIXCODE logo.png"
            alt="solvixcode-logo"
            className="logo-img"
          />
        </Link>
        <ul className="nav-menu">
          <li>
            <NavLink to="/" className={buildLinkClass}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/portfolio" className={buildLinkClass}>
              Portfolio
            </NavLink>
          </li>
          {/* <li>
            <NavLink to="/blog" className={buildLinkClass}>
              Blog
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className={buildLinkClass}>
              Contact
            </NavLink>
          </li> */}
        </ul>
        <ul className="nav-links">
          <li>
            <a
              href="https://github.com/Olha-Fursova"
              className={css["icon-link"]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className={`icon icon-nav ${css.mobile}`}>
                <use href="/img/icons.svg#icon-github"></use>
              </svg>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/olha-fursova-6727b7265/"
              className={css["icon-link"]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className={`icon icon-nav ${css.mobile}`}>
                <use href="/img/icons.svg#icon-linkedin"></use>
              </svg>
            </a>
          </li>
        </ul>
        {!isMobileMenuOpen && (
          <button
            className={css["js-open-menu"]}
            type="button"
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
            aria-label="open menu"
            onClick={() => setIsMobileMenuOpen(true)}
          >
            <svg className={`icon ${css["mobile-menu-btn-icon"]}`}>
              <use href="/img/icons.svg#icon-mobile-menu-button"></use>
            </svg>
          </button>
        )}
        <MobileMenuHome
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
        />
      </nav>
    </header>
  );
}
